// @flow

import _ from "lodash";
import assert from "assert";
import React, { Component } from "react";

import Spinner from "../Spinner/Spinner";

type Props = Object; // FIXME

type State = {
  loading: boolean,
  initialLoadFinished: boolean
};

const WithLoadingIndicator = (InnerComponent: any) => {
  return class extends Component<Props, State> {
    constructor(props: Props) {
      super(props);
      this.state = {
        loading: true,
        initialLoadFinished: false
      };
    }

    componentDidMount() {
      this.setState(this.propsToState(this.props));
    }

    componentWillReceiveProps(nextProps: Props) {
      this.setState(this.propsToState(nextProps));
    }

    propsToState(props: Props) {
      // Checks if any gql data is loading by looking for keys that end with "Data"
      const loading = _(props)
        .pickBy((v, k) => k.endsWith("Data"))
        .reduce((acc, value, key) => acc || value["loading"], false);
      return {
        loading,
        initialLoadFinished: this.state.initialLoadFinished || !loading
      };
    }

    render() {
      if (!this.state.initialLoadFinished) {
        assert.ok(
          this.state.loading,
          "If initialLoadFinished=false, loading should be true"
        );
        return <Spinner />;
      } else {
        // Once initial load is finished, always render Inner,
        // even if we don't return it
        const inner = <InnerComponent {...this.props} />;
        if (this.state.loading) {
          return <Spinner />;
        } else {
          return inner;
        }
      }
    }
  };
};

export default WithLoadingIndicator;



// WEBPACK FOOTER //
// ./src/components/WithLoadingIndicator/WithLoadingIndicator.js